import { configItemsSubscription } from './utils/payment';
import { WrapperCard } from './WrapperCard';

export function PaymentInfo() {
  return (
    <WrapperCard renderTop={() => <p className="uppercase">входит в вашу подписку</p>}>
      <ul className='space-y-3'>
        {configItemsSubscription.map((i) => (
          <li key={i.title} className="flex items-center gap-2">
            <img src={i.iconUrl} alt="icon" className="size-[20px] shrink-0" />
            <p className="text-[16px] text-white">{i.title}</p>
          </li>
        ))}
      </ul>
    </WrapperCard>
  );
}
